var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAngular2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 240,
    height: 120,
    viewBox: "0 0 240 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-_13"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 120
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_13",
    "data-name": 13,
    clipPath: "url(#clip-_13)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "angular-seeklogo.com",
    transform: "translate(30 35.742)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20018",
    "data-name": "Group 20018"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20016",
    "data-name": "Group 20016",
    transform: "translate(53.088 11.104)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_111250",
    "data-name": "Path 111250",
    d: "M.6,31.008V8.8H3.455L17.027,26.672V8.8h2.714V31.008H16.886L3.314,12.96V31.008Z",
    transform: "translate(-0.6 -5.874)",
    fill: "#b52e31",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111251",
    "data-name": "Path 111251",
    d: "M84.837,29.8a16.482,16.482,0,0,1-5.781,1.022Q67,30.825,67,19.263,67,8.318,78.633,8.3a20.616,20.616,0,0,1,6.2.917v2.468a16.134,16.134,0,0,0-5.887-1.093c-6.063,0-9.095,2.891-9.095,8.6,0,6.169,3,9.236,8.954,9.236a15.522,15.522,0,0,0,3.173-.388V20.6h2.855v9.2Z",
    transform: "translate(-43.593 -5.55)",
    fill: "#b52e31",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111252",
    "data-name": "Path 111252",
    d: "M130.6,22.442V8.8h2.855V22.442c0,4.265,2.115,6.416,6.38,6.416,4.23,0,6.38-2.15,6.38-6.416V8.8h2.855V22.442c0,5.816-3.067,8.742-9.236,8.742s-9.236-2.926-9.236-8.742Z",
    transform: "translate(-84.774 -5.874)",
    fill: "#b52e31",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111253",
    "data-name": "Path 111253",
    d: "M200.355,8.8V28.682h11.633v2.327H197.5V8.8Z",
    transform: "translate(-128.091 -5.874)",
    fill: "#b52e31",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111254",
    "data-name": "Path 111254",
    d: "M244.8,25.634h-3L252.834.5l11.034,25.134h-3.173l-2.855-6.98h-7.332l.776-2.327h5.6l-4.16-10.047L244.8,25.634Z",
    transform: "translate(-156.775 -0.5)",
    fill: "#b52e31",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111255",
    "data-name": "Path 111255",
    d: "M313.1,31.008V8.8h9.483c4.23,0,6.345,1.763,6.345,5.323,0,2.891-2.08,5.041-6.2,6.416l7.614,10.47h-3.772l-7.05-9.976V19.164c4.23-.67,6.38-2.291,6.38-4.9,0-2.045-1.163-3.067-3.525-3.067h-6.345V31.008Z",
    transform: "translate(-202.94 -5.874)",
    fill: "#b52e31",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20017",
    "data-name": "Group 20017"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_111256",
    "data-name": "Path 111256",
    d: "M0,8.108,22.737,0,46.073,7.967,42.3,38.036,22.737,48.858,3.49,38.177,0,8.108Z",
    fill: "#e23237",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111257",
    "data-name": "Path 111257",
    d: "M87.836,7.967,64.5,0V48.858L84.064,38.036,87.836,7.967Z",
    transform: "translate(-41.763)",
    fill: "#b52e31",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111258",
    "data-name": "Path 111258",
    d: "M38.571,16.2h0L24.4,47.714l5.288-.106,2.855-7.121H45.2l3.1,7.191,5.041.106L38.571,16.2Zm.035,10.117L43.4,36.328H34.411l4.195-10.011Z",
    transform: "translate(-15.799 -10.489)",
    fill: "#fff",
    fillRule: "evenodd"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngular2);
export default __webpack_public_path__ + "static/media/angular-2.011611391ae7297c961247f1b54e29d0.svg";
export { ForwardRef as ReactComponent };